import { ViewerContext, ViewerContextData } from "context/ViewerContext";

import { useContext } from "react";

export default function useViewerContext(): ViewerContextData {
  return useContext(ViewerContext);
}
